module.exports = __webpack_public_path__ + "img/banquet-icon.80d7a412.svg";